import React, { Component } from 'react';
import Breadcrumb from 'molecules/Breadcrumb';
import { actualLoadingCreate, actualLoadingDelete, actualLoadingUpdate} from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Footer, LevelRowContainer, PageWrapper } from './styles';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import lo from 'lodash';
import { NewActualLoadingFinalize } from 'fixtures/TemplateData'
import ButtonReg from 'components/atoms/Buttons/Button';
import WaitingTugboatBarge from 'components/organisms/ActualLoadingFinalizeForm/WaitingTugboatBarge';
import LoadingDelayedInformation from 'components/organisms/ActualLoadingFinalizeForm/LoadingDelayedInformation';
import InProcessLoading from 'components/organisms/ActualLoadingFinalizeForm/InProcessLoading';
import SummaryLossTime from 'components/organisms/ActualLoadingFinalizeForm/SummaryLossTime';
import WaterLevelWeather from 'components/organisms/ActualLoadingFinalizeForm/WaterLevelWeather';
import { getAllList, postNewData } from 'services/cmsService';
import { BARGE_LOADINGS_FINALIZE } from 'fixtures/api';
import moment from 'moment';

export class ActualLoadingFinalizeForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      form: lo.cloneDeep(NewActualLoadingFinalize),
      filter: {
        loadingDate: null,
      },
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.getFilterData()
    this.checkPermission()
    this.props.toggleIsLoading(false)
  }

  componentDidUpdate(prevProps) {
    const { userLogin } = this.props
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
  }

  getFilterData() {
    const { location: { search }, history} = this.props
    const query = new URLSearchParams(search)
    if ( !query.get('loadingDate') ){
      history.goBack()
    }
    const filter = {
      site: query.get('site'),
      shipmentType: query.get('shipmentType'),
      loadingDate: query.get('loadingDate'),
      search: query.get('search'),
    }
    this.setState({ filter: lo.omitBy(filter, (val) => !val)}, () => {
      this.fetchDetail()
    })
  }

  fetchDetail = async () => {
    try {
      this.props.toggleIsLoading(true)
      const { filter, form } = this.state
      const params = new URLSearchParams(filter).toString()
      const data = await getAllList(`${BARGE_LOADINGS_FINALIZE}${!!params ? `?${params}` : ''}`)
      if (data) {
        const dataValid = lo.pick(data, ['inProcessLoading','loadingDelayedDateTime','loadingDelayedInformation','loadingDelayedUnit', 'summaryLossTime', 'waitingTugboatBarge', 'waterLevelWeather'])
        if (!lo.some(dataValid, lo.isEmpty)){
          this.setState({ form: { ...form, ...data} })
        }
      } else {
        const newData = lo.cloneDeep(this.state.form)
        newData.summaryLossTime.date = moment(filter.loadingDate).format('DD-MMM-YYYY')
        this.setState({ form: newData })
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.props.toggleIsLoading(false)
    }
  }

  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, actualLoadingCreate),
        allowDelete: permissionCheck(permissions, actualLoadingDelete),
        allowUpdate: permissionCheck(permissions, actualLoadingUpdate),
      })
    }
  }

  onChange = (key, val) => {
    const form = lo.cloneDeep(this.state.form)
    form[key] = val
    this.setState({ form })
  }

  onChangeForm = (form) => {
    this.setState({ form })
  }

  onCancel = () => {
    if (this.props.location.state && this.props.location.state.from) {
      this.props.history.goBack()
    } else {
      this.props.history.push({
        pathname: '/dash/actual-loading',
        search: "?" + new URLSearchParams(this.state.filter).toString()
      })
    }
  }

  onSubmit = async () => {
    const { toggleIsLoading } = this.props
    try {
      toggleIsLoading(true)
      const { form, filter } = this.state
      const body = lo.cloneDeep(form)
      body.loadingDate = filter.loadingDate
      const res = await postNewData(BARGE_LOADINGS_FINALIZE, lo.omit(body, ['id','date', 'notificationSentAt', 'createdAt', 'createdBy', 'updatedAt', 'updatedBy']))

      if (res.status < 400) {
        this.onCancel()
      } else {
        const message = res.message ? res.message : `Failed to finalize actual loading`
        alert(message)
        throw res
      }
    } catch (error) {
      console.error(error);
    } finally {
      toggleIsLoading(false)
    }
  }

  render() {
    const { form, filter } = this.state
    const navList = [
      'Actual Loading',
      'Finalize and Send Daily Barge Report'
    ]
    const { viewState: { isMobileView } } = this.props

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList} />
        <LoadingDelayedInformation form={form} onChange={this.onChange} filter={filter}/>
        <InProcessLoading form={form} onChange={this.onChange} />
        <WaitingTugboatBarge form={form} onChange={this.onChange} />
        <LevelRowContainer>
          <SummaryLossTime form={form} onChange={this.onChange} filter={filter} />
          <WaterLevelWeather form={form} onChange={this.onChange} />
        </LevelRowContainer>
        <Footer>
          <ButtonReg
            transparent
            btnTxt={'Cancel'}
            onClick={() => this.onCancel()}
            width={'150px'}
            margin="0 10px 0 0"
          />
          <ButtonReg
            btnTxt={'Finalize'}
            disabled={!filter.loadingDate}
            onClick={() => this.onSubmit()}
            width={'150px'}
          />
        </Footer>
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {

  return {
    userLogin: state.userLogin,
    viewState: state.viewState,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingFinalizeForm)
  )
);
